<div class="Loyalty ui-g-12 ui-md-12 ui-lg-12" *ngIf="fields && texts">
  <div class="" *ngIf="ready.form">
    <div class="card">

      <div class="ui-g" *ngIf="card_id == 0">
        <div class="ui-g-10 ui-md-10 ui-lg-10">
          <h3 class="title">{{texts.title}}</h3>
        </div>
        <!-- pulsanti disponibili solamente in caso di pulsante "Aggiungi" da sezione Movimenti -->
        <div class="ui-g-2 ui-md-2 ui-lg-2 form-button-row">
          <button pButton type="button" class="k-generic-btn" icon="fa fa-arrow-left"
            iconPos="left" routerLink="/loyalty/movement" label="{{ 'common.back' | translate }}"></button>
          <button *ngIf="ready.form && readonly!=true" pButton (click)="save()" type="button"
            class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left" label="Salva" [disabled]="readonly==true"></button>
        </div>
      </div>

      <div [ngClass]="{'invalid-submit': invalidSubmit}">
        <br />

        <div class="ui-g ui-fluid">

          <!-- ricerca per customer (casella ricerca) -->
          <!--<div class="ui-g-12 ui-md-4" *ngIf="(searchType == '' || searchType == 'customer') && ready.form && readonly!=true">
            <span class="label" [ngClass]="{'required': !fields.customer_id.nullable && !readonly}">{{ fields.customer_id.keyName }}</span>
            <p-autoComplete id="customerAutocomplete" [suggestions]="customers" [(ngModel)]="selected.customer"
              value="selected.customer.denominazione" (completeMethod)="filterCustomerSingle($event)"
              (onSelect)="customerIdSelect($event)" placeholder="{{ fields.customer_id.keyName }}" (onClear)="onClearCustomer()"
              [minLength]="2" field="contactName">
              <ng-template let-customer pTemplate="item">
                <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                  <div>{{ customer.contactCodeName }}</div>
                </div>
              </ng-template>
            </p-autoComplete>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.customer_id"></app-validation-msg>
          </div>-->

          <!-- customer name caso readonly e caso calcolato dalla carta scelta -->
          <!--<div class="ui-g-12 ui-md-4" *ngIf="searchType == 'card' || readonly==true">
              <span class="label" [ngClass]="{'required': !fields.customer_id.nullable && !readonly}">{{ fields.customer_id.keyName }}</span>
              <input type="text" pInputText class="fieldInput" [(ngModel)]="model.customer_name" disabled="disabled" />
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.customer_id"></app-validation-msg>
          </div>-->

          <!-- ricerca per carta (casella ricerca) -->
          <!--<div class="ui-g-12 ui-md-4" *ngIf="(searchType == '' || searchType == 'card') && ready.form && readonly!=true">
            <span class="label card-no" [ngClass]="{'required': !fields.card_no.nullable && !readonly}">
              {{ fields.card_no.keyName }} &nbsp; {{texts.cardLimitCharacters}}
            </span>
            <p-autoComplete id="cardAutocomplete" [suggestions]="cards" [(ngModel)]="selected.card" [disabled]="card_id > 0 ? '' : null"
              value="selected.card" (completeMethod)="filterCardSingle($event)" (onSelect)="cardIdSelect($event)"
              (onClear)="onClearCustomer()" placeholder="{{ fields.card_id.keyName }}" [minLength]="6" field="card_no">
              <ng-template let-card pTemplate="item">
                <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                  <div>{{ card.card_no }}</div>
                </div>
              </ng-template>
            </p-autoComplete>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.card_no"></app-validation-msg>
          </div>-->

          <!-- dropdown di carte legate all'utente calcolato dal customer scelto -->
          <!--<div class="ui-g-12 ui-md-4" *ngIf="searchType == 'customer' && readonly!=true">
              <span class="label" [ngClass]="{'required': !fields.card_no.nullable && !readonly}">{{ fields.card_no.keyName }}</span>
              <input *ngIf="readonly==true" type="text" pInputText class="fieldInput" value="value.card_no"
                disabled="disabled" />
              <p-dropdown #cardId data-testid="cardId" *ngIf="readonly!=true" [options]="cards" [(ngModel)]="model.card_no_select"
                (onChange)="onCardChange()" [attr.disabled]="readonly == true ? '' : null"></p-dropdown>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.card_no"></app-validation-msg>
          </div>-->

          <!-- numero carta caso readonly -->
          <!--<div class="ui-g-12 ui-md-4" *ngIf="readonly==true">
              <span class="label" [ngClass]="{'required': !fields.card_no.nullable && !readonly}">{{ fields.card_no.keyName }}</span>
              <input type="text" pInputText class="fieldInput" [(ngModel)]="model.card_no_select" disabled="disabled" />
          </div>-->
          <!-- KS-2632: Introdotto il campo "Ricerca Carta" in sostituzione della vecchia logica (per tutti i clienti!!!) -->
          <div class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.card_no.nullable}">{{ 'common.card_search' | translate }}</span>
            <input disabled type="text" style="width: calc(100% - 70px) !important;float:left;" [disabled]="isCardInputPresent" pInputText class="inputSelect" [(ngModel)]="model.card_no_select" placeholder="{{'pointTransfer.selectCardPlaceholder' | translate}}" />
            <p-button *ngIf="!readonly && !card_id" pTooltip="{{ 'common.select' | translate }}" [disabled]="isCardInputPresent && insertedOnce" icon="fa fas fa-arrow-circle-right"  styleClass="selectButtonArrow ui-button-info" (onClick)="onOpenSelectCardSource()"></p-button>
            <p-button *ngIf="isCardInputPresent" pTooltip="{{ 'common.clear' | translate }}" icon="fa fa-close"  styleClass="selectButtonArrow ui-button-info" (onClick)="clearCardSearch()"></p-button>
          </div>
        </div>


      </div>




      <form [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}" (submit)="save()" *ngIf="ready.form2">

        <div class="ui-g ui-fluid">

          <div class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.division_id.nullable && !readonly}">{{ texts.division_id }}</span>
            <input *ngIf="readonly==true" type="text" pInputText class="fieldInput"
              formControlName="division_description" disabled="disabled" />
            <p-dropdown *ngIf="readonly!=true" #divisionId data-testid="divisionId" [options]="divisions" formControlName="division_id"
              (onChange)="divisionIdSelect($event, divisionId)" [disabled]="readonly || divisionFieldDisabled"
              [(ngModel)]="selected.division" ></p-dropdown>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.division_id"></app-validation-msg>
          </div>

          <!--<div class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.store_id.nullable && !readonly}">{{ fields.store_id.keyName }}</span>
            <input *ngIf="readonly==true" type="text" pInputText class="fieldInput" formControlName="store_name"
              disabled="disabled" />
            <p-dropdown #storeId data-testid="storeId" *ngIf="readonly!=true" (onChange)="storeChange($event.value)" [options]="stores"
              formControlName="store_id" [attr.disabled]="!selected.division ? '' : null" [disabled]="divisionFieldDisabled" [filter]="true"></p-dropdown>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.store_id"></app-validation-msg>
          </div>-->

          <div class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.store_id.nullable && !readonly}">{{ texts.store }}</span>
            <input *ngIf="readonly==true" type="text" pInputText class="fieldInput" formControlName="store_name"
              disabled="disabled" />
            <app-store-autocomplete
            #storeId data-testid="storeId"
            *ngIf="readonly!=true"
            formControlName="store_id"
            ngDefaultControl
            [storeDetailComplete]="true"
            [filters]="storeFilters"
            [selectedStore]="selectedStore"
            (selectedStoreChange)="changeStore($event)"
            [attr.disabled]="!selected.division ? '' : null"
            [disabled]="divisionFieldDisabled || (!divisionFieldDisabled && !selected.division)"
            >
            </app-store-autocomplete>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.store_id"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4">
            <span class="label">{{ texts.channel_name }}</span>
            <input type="text" pInputText class="fieldInput" formControlName="channel_name" disabled="disabled" />
          </div>


          <div class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.acm_id.nullable && !readonly}">{{ texts.acm_id }}</span>
            <input *ngIf="readonly==true" type="text" pInputText class="fieldInput" formControlName="acm_description"
              disabled="disabled" />

            <p-autoComplete
            *ngIf="readonly!=true"
            id="acmAutocomplete"
            [suggestions]="listAcm"
            [(ngModel)]="selected.acm"
            value="selected.acm"
            formControlName="acm_id"
            (completeMethod)="filterAcmSingle($event)"
            (onSelect)="acmIdSelect($event)"
            placeholder="{{ fields.acm_id.keyName }}"
            [minLength]="2"
            field="acmDescription"
            [dropdown]="true">
              <ng-template let-acm pTemplate="item">
                <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                  <div>{{ acm.acmCodeDescription }}</div>
                </div>
              </ng-template>
            </p-autoComplete>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.acm_id"></app-validation-msg>

          </div>

          <div class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.reason_id.nullable && !readonly}">{{ fields.reason_id.keyName }}</span>
            <input *ngIf="readonly==true" type="text" pInputText class="fieldInput" formControlName="reason_description"
              disabled="disabled" />
            <p-dropdown *ngIf="readonly!=true" #reasonId data-testid="reasonId" [options]="reasons" formControlName="reason_id"
              [attr.disabled]="disabled.reason ? '' : null" (onChange)="reasonChange(reasonId)"></p-dropdown>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.reason_id"></app-validation-msg>
          </div>


          <div *ngIf="!customerMgPermission" class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.term_id.nullable && !readonly}">{{ texts.cash_desk }}</span>
            <input type="number" pInputText class="fieldInput" formControlName="term_id" [attr.disabled]="readonly == true ? '' : null" />
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.term_id"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" [hidden]="readonly != true">
            <span class="label" [ngClass]="{'required': !fields.action_type.nullable && !readonly}">{{ fields.action_type.keyName }}</span>
            <input type="text" pInputText class="fieldInput" formControlName="action_type" disabled="disabled" />
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.action_type"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" [hidden]="readonly != true">
            <span class="label" [ngClass]="{'required': !fields.promo_code.nullable && !readonly}">{{ fields.promo_code.keyName }}</span>
            <input type="text" pInputText class="fieldInput" formControlName="promo_code"
              [attr.disabled]="readonly==true ? '' : null" />
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.promo_code"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" *ngIf="readonly == true">
            <span class="label" [ngClass]="{'required': !fields.xact_id.nullable && !readonly}">{{ texts.xact_id }}</span>
            <input type="text" disabled="disabled" pInputText class="fieldInput" formControlName="xact_id" />
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.xact_id"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" *ngIf="readonly == true">
            <span class="label" [ngClass]="{'required': !fields.sequence_id.nullable && !readonly}">{{ fields.sequence_id.keyName }}</span>
            <input type="text" disabled="disabled" pInputText class="fieldInput" formControlName="sequence_id" />
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.sequence_id"></app-validation-msg>
          </div>

          <div *ngIf="!customerMgPermission" class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.xact_date.nullable && !readonly}">{{ texts.xact_date }}</span>
            <p-calendar  *ngIf="!readonly"
             formControlName="xact_date"
              [dateFormat]="calendarTranslate.pcalendarTranslate.dateFormat" 
              [locale]="calendarTranslate.pcalendarTranslate"
               [maxDate]="today"
                showIcon="true"
                ></p-calendar >
            <input type="text" *ngIf="readonly" disabled="disabled" pInputText class="fieldInput" formControlName="xact_date" />
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.xact_date"></app-validation-msg>
          </div>

          <div *ngIf="!customerMgPermission" class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.xact_time.nullable && !readonly}">{{ texts.xact_time }}</span>
            <p-calendar *ngIf="!readonly" [timeOnly]="true" formControlName="xact_time" placeholder="hh:mm"></p-calendar>
            <input type="text" *ngIf="readonly" disabled="disabled" pInputText class="fieldInput" formControlName="xact_time" />
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.xact_time"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.value.nullable && !readonly}">{{ fields.value.keyName }}
              <!--
                ** Dayana ci segnala che i valori negativi non sono accettati,
                  quindi la label "(valore negativo)" non è corretta
                  e vanno obbligati valori >= 1
                **
                <span *ngIf="signValue == '+'">{{ texts.positiveValue }}</span>
                <span *ngIf="signValue == '-'">{{ texts.negativeValue }}</span>
              -->
            </span>
            <input type="number" min="1"
              pInputText step="1" class="fieldInput" formControlName="value"
              [attr.disabled]="readonly == true ? '' : null" oninput="this.value = Math.round(this.value);" />
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.value"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" [hidden]="readonly != true">
            <span class="label" [ngClass]="{'required': !fields.value_2.nullable && !readonly}">{{ fields.value_2.keyName }}</span>
            <input type="number" pInputText step="0.01" class="fieldInput" formControlName="value2"
              [attr.disabled]="readonly == true ? '' : null" />
          </div>

        </div>

        <div class="ui-g ui-fluid">

          <div class="ui-g-12 ui-md-4" *ngIf="readonly == true">
            <span class="label" [ngClass]="{'required': !fields.previous_balance.nullable && !readonly}">{{ texts.previous_balance }}</span>
            <input type="text" step="0.01" pInputText class="fieldInput" formControlName="previous_balance"
              [attr.disabled]="readonly == true ? '' : null" />
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.previous_balance"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" *ngIf="readonly == true">
            <span class="label" [ngClass]="{'required': !fields.previous_balance_2.nullable && !readonly}">{{ texts.previous_balance_2 }}</span>
            <input type="text" step="0.01" pInputText class="fieldInput" formControlName="previous_balance_2"
              [attr.disabled]="readonly == true ? '' : null" />
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.previous_balance_2"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" [hidden]="!isPremio && readonly != true">
            <span class="label" [ngClass]="{'required': !fields.item_code.nullable && !readonly}">{{ fields.item_code.keyName }}</span>
            <input type="text" pInputText class="fieldInput" formControlName="item_code"
              [attr.disabled]="readonly == true ? '' : null" />
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.item_code"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" [hidden]="!isPremio && readonly != true">
            <span class="label" [ngClass]="{'required': !fields.ean.nullable && !readonly}">{{ fields.ean.keyName }}</span>
            <input type="text" pInputText class="fieldInput" formControlName="ean"
              [attr.disabled]="readonly == true ? '' : null" />
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.ean"></app-validation-msg>
          </div>
        </div>
        <div class="ui-g ui-fluid">
          <div class="ui-g-12 ui-md-4" [hidden]="!isPremio && readonly != true">
            <span class="label" [ngClass]="{'required': !fields.obj_code.nullable && !readonly}">{{ fields.obj_code.keyName }}</span>
            <input type="text" pInputText class="fieldInput" formControlName="obj_code"
              [attr.disabled]="readonly == true ? '' : null" />
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.obj_code"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" [hidden]="!isPremio && readonly != true">
            <span class="label" [ngClass]="{'required': !fields.object_value.nullable && !readonly}">{{ fields.object_value.keyName }}</span>
            <input type="number" pInputText step="0.01" class="fieldInput" formControlName="object_value"
              [attr.disabled]="readonly == true ? '' : null" />
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.object_value"></app-validation-msg>
          </div>

          <div class="ui-g-12 ui-md-4" [hidden]="!isPremio && readonly != true">
            <span class="label" [ngClass]="{'required': !fields.qty.nullable && !readonly}">{{ fields.qty.keyName }}</span>
            <input type="number" pInputText class="fieldInput" formControlName="qty"
              [attr.disabled]="readonly == true ? '' : null" />
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.qty"></app-validation-msg>
          </div>
        </div>

        <br />
        <button *ngIf="ready.form && readonly!=true && card_id > 0" pButton (click)="save()" type="button"
          class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left" label="Salva" [disabled]="readonly==true"></button>

      </form>
    </div>
    <!-- modal selezione carta sorgente -->
    <p-dialog [(visible)]="ready.selectCardSource"
              header="{{ 'card.select_card' | translate }}"
              [responsive]="true"
              showEffect="fade"
              [modal]="true">
    <app-card-selection-table 
      *ngIf="ready.selectCardSource && !readonly" [flgBlkLst]="customerMgPermission ? '0' : false" 
      [cardNo]="model.card_no_select"
      (onCardSelect)="onSourceCardSelected($event)"
      [hideCustomerInfoPermission]="customerHideInfoPermission">
    </app-card-selection-table>
    </p-dialog>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-movement/form-movement-loyalty/form-movement-loyalty.component.html